var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMyWishlist(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 83,
    height: 83.002,
    viewBox: "0 0 83 83.002",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "my_wishlist",
    transform: "translate(0 0.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8436",
    "data-name": "Path 8436",
    d: "M33.569,41.667a1.74,1.74,0,0,1-1.038-.344C31.649,40.667,11,25.108,11,12.6A12.61,12.61,0,0,1,33.569,4.875,12.61,12.61,0,0,1,56.139,12.6c0,12.5-20.649,28.063-21.531,28.719A1.74,1.74,0,0,1,33.569,41.667ZM23.608,3.472A9.146,9.146,0,0,0,14.472,12.6c0,8.427,12.931,20.306,19.1,25.139,6.167-4.833,19.1-16.708,19.1-25.139a9.133,9.133,0,0,0-17.5-3.653,1.738,1.738,0,0,1-3.187,0,9.1,9.1,0,0,0-8.368-5.479Z",
    transform: "translate(26.861)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8437",
    "data-name": "Path 8437",
    d: "M57.819,44.195H12.68a1.736,1.736,0,0,1-1.7-1.4L4.035,8.076A1.733,1.733,0,0,1,5.736,6H23.1a1.736,1.736,0,1,1,0,3.472H7.854l6.25,31.25H56.4l2.847-14.229a1.737,1.737,0,1,1,3.406.681L59.524,42.8a1.742,1.742,0,0,1-1.705,1.4Z",
    transform: "translate(9.556 14.679)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8438",
    "data-name": "Path 8438",
    d: "M22.566,54.088a1.735,1.735,0,0,1-1.7-1.4L12.26,9.658A5.222,5.222,0,0,0,7.153,5.47h0l-5.41.007h0A1.739,1.739,0,1,1,1.733,2H7.152a8.7,8.7,0,0,1,8.514,6.979l8.6,43.035A1.731,1.731,0,0,1,22.9,54.056a1.594,1.594,0,0,1-.34.035Z",
    transform: "translate(0 4.94)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8439",
    "data-name": "Path 8439",
    d: "M66.912,26.417H8.182A5.208,5.208,0,0,1,8.182,16h6.909a1.736,1.736,0,1,1,0,3.472H8.182a1.736,1.736,0,1,0,0,3.472h58.73a1.736,1.736,0,1,1,0,3.472Z",
    transform: "translate(7.417 39.302)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8440",
    "data-name": "Path 8440",
    d: "M12.944,33.889a6.944,6.944,0,1,1,6.944-6.944,6.944,6.944,0,0,1-6.944,6.944Zm0-10.417a3.472,3.472,0,1,0,3.472,3.472,3.472,3.472,0,0,0-3.472-3.472Z",
    transform: "translate(14.733 49.111)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8441",
    "data-name": "Path 8441",
    d: "M21.944,33.889a6.944,6.944,0,1,1,6.944-6.944A6.944,6.944,0,0,1,21.944,33.889Zm0-10.417a3.472,3.472,0,1,0,3.472,3.472,3.472,3.472,0,0,0-3.472-3.472Z",
    transform: "translate(36.833 49.111)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyWishlist);
export default __webpack_public_path__ + "static/media/my_wishlist.08c5764fb8e460594452f157942765df.svg";
export { ForwardRef as ReactComponent };